// extracted by mini-css-extract-plugin
export default {"separator":"g3D6p","postExcerpt":"jxSuh","postTitle":"eZHeM"};